import Button from "react-bootstrap/Button";
import React from "react";
import Modal from "react-bootstrap/Modal";
import LoaderButton from "./LoaderButton";
import { useSelector } from "react-redux";
import SmallLoaderButton from "./SmallLoaderButton";
const CommonModal = React.memo((props) => {
  const actionData = useSelector((state) => state.action);
  const handleSubmit = () => {
    props.handleSubmit();
  };
  return (
    <>
      <Modal
        show={props.isModalOpen}
        onHide={(e) => props.setIsModalOpen(false)}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>{props.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{props.message}</Modal.Body>
        <Modal.Footer>
          {props.isCalledFromOthers === true ? (
            <>
              {!props.updateLoading &&
              props.isCalledFromOthers === true ? (
                <Button
                  variant=""
                  className="add-minutes Mom-btn"
                  onClick={handleSubmit}
                >
                  <p>Yes</p>
                </Button>
              ) : (
                <SmallLoaderButton />
              )}
            </>
          ) : (
            <Button
              variant=""
              className="add-minutes Mom-btn"
              onClick={handleSubmit}
            >
              <p>Yes</p>
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
});

export default CommonModal;
